module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "display": "none",
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "400px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Feeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fas fa-store-alt",
    attrs: {
      "id": "m_trending"
    }
  }), _c('br'), _c('span', [_vm._v("Trending")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "id": "m_account"
    }
  }), _c('br'), _c('span', [_vm._v("Orders")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottombar sp-app=default-background-color",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('div', [_c('button', {
    staticClass: "sp-button-02 sp-button-oo"
  }, [_vm._v(" Place Order")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8ca4956"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/menubottom.vue
// module id = 493
// module chunks = 0